// NOPE: only show a single popup, not one in Czech and another one in English…
//  XXX: though, luckily, they are ordered correctly at least, and a popup for
//       the current language shows on top – so not a big issue
// NOTE: the only way is to patch jquery-eu-cookie-law-popup.js manually and
//       disable its $(document).ready() call; it doesn’t matter much though
$(document.documentElement).ready(() => {
    if ($(".eupopup").length > 0) {
        $(document.documentElement).euCookieLawPopup().init({
            //  XXX: this overrides the (formerly) compiled-in eupopup-fixedtop
            popupPosition: 'bottom',
            //popupTitle: "This website is using cookies.",
            //popupText: "We use them to give you the best experience. If you continue using our website, we'll assume that you are happy to receive all cookies on this website.",
            popupTitle: localization.translate("WebUseCookies", "PluginsJs").value,
            popupText: localization.translate("CookieInfo", "PluginsJs").value,
            buttonContinueTitle: localization.translate("Continue", "PluginsJs").value,
            buttonLearnmoreTitle: localization.translate("LearnMore", "PluginsJs").value,
            cookiePolicyUrl: "https://www.google.com/search?q=Eu+cookie+policy&oq=Eu+cookie+policy"
        });
    }
});
